export default "__VITE_ASSET__E$GNd141__"